<svg  viewBox="0 0 36 47" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" stroke-width='2' d="M18.6778 42.5562V0H16.6778V42.5565L1.41421 27.2929L0 28.7071L16.9706 45.6777L17.6777 46.3848L18.3848 45.6777L35.3553 28.7071L33.9411 27.2929L18.6778 42.5562Z" />
</svg>
